import React from "react";
import PopulationService from "../../../Services/Population.service";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
const PAGE_SIZE = 20;
// @ts-expect-error dumb react typing -- will be fixed when we upgrade
const PersonPopulationMembersSharedWithTable = ({ populationId, }) => {
    const searchArgs = React.useMemo(() => ({ populationId }), [populationId]);
    const { table } = usePagedSortedTable({
        noDataComponent: "No people found in filter",
        searchArgs,
        addMarginToPager: true,
        getData: (sort, pageNumber, sArgs) => {
            return PopulationService.getPeopleSharedWith({
                populationId: sArgs.populationId,
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
            });
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "Id",
                size: 2,
            },
            {
                title: "Name",
                size: 3,
            },
            {
                title: "Email",
                size: 3,
            },
        ],
        rows: ({ data }) => data.map((person) => {
            return [person.studentId, person.fullName, person.emailAddress];
        }),
    });
    return table;
};
export default PersonPopulationMembersSharedWithTable;
